/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TrademarkRequestList200ResponseDataTrademarkRequestsInner
 */
export interface TrademarkRequestList200ResponseDataTrademarkRequestsInner {
  /**
   * Id заявки
   * @type {number}
   * @memberof TrademarkRequestList200ResponseDataTrademarkRequestsInner
   */
  id: number
  /**
   * Форматированный заголовок: «Заявка на продление срока действия ТЗ <регистры>»
   * @type {string}
   * @memberof TrademarkRequestList200ResponseDataTrademarkRequestsInner
   */
  label: string
  /**
   * Статус: 0 — Draft, 1 — Moderation, 2 — Submitted, 3 — Archive
   * @type {number}
   * @memberof TrademarkRequestList200ResponseDataTrademarkRequestsInner
   */
  status: TrademarkRequestList200ResponseDataTrademarkRequestsInnerStatusEnum
  /**
   * Ссылки на изображения регистров заявки
   * @type {Array<string>}
   * @memberof TrademarkRequestList200ResponseDataTrademarkRequestsInner
   */
  images: Array<string>
}

/**
 * @export
 * @enum {string}
 */
export enum TrademarkRequestList200ResponseDataTrademarkRequestsInnerStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
}

/**
 * Check if a given object implements the TrademarkRequestList200ResponseDataTrademarkRequestsInner interface.
 */
export function instanceOfTrademarkRequestList200ResponseDataTrademarkRequestsInner(
  value: object
): value is TrademarkRequestList200ResponseDataTrademarkRequestsInner {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('label' in value) || value['label'] === undefined) return false
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('images' in value) || value['images'] === undefined) return false
  return true
}

export function TrademarkRequestList200ResponseDataTrademarkRequestsInnerFromJSON(
  json: any
): TrademarkRequestList200ResponseDataTrademarkRequestsInner {
  return TrademarkRequestList200ResponseDataTrademarkRequestsInnerFromJSONTyped(
    json,
    false
  )
}

export function TrademarkRequestList200ResponseDataTrademarkRequestsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TrademarkRequestList200ResponseDataTrademarkRequestsInner {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    label: json['label'],
    status: json['status'],
    images: json['images'],
  }
}

export function TrademarkRequestList200ResponseDataTrademarkRequestsInnerToJSON(
  value?: TrademarkRequestList200ResponseDataTrademarkRequestsInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    label: value['label'],
    status: value['status'],
    images: value['images'],
  }
}
